import {
  downloadTemplateDOCX,
  downloadTemplatePDF,
  generateTemplateHTML,
} from './htmlResumeTemplates';

export async function generateExecutiveDOCX(resumeData: any): Promise<void> {
  return downloadTemplateDOCX('executive', resumeData);
}

export async function generateExecutivePDF(resumeData: any): Promise<void> {
  return downloadTemplatePDF('executive', resumeData);
}

export async function generateExecutiveHTML(resumeData: any): Promise<string> {
  return generateTemplateHTML('executive', resumeData);
}
